/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';

import { IMeetingLiveItemsProps } from './types';
import { useSelect } from '../../../../../utils/selector.utils';
import { meetingsSimplePageSelectors } from '../../../../../app/page/page-storage/meetings-simple/meetings-simple.selectors';
import { authSelectors } from '../../../../../app/auth/auth.selectors';
import { useDispatch } from 'react-redux';
import { joinMeeting } from '../../../../../app/page/page-storage/meetings-simple/meetings-simple.actions';
import { CircularAvatar } from '../../CustomAvatar';
import { useHistory } from 'react-router-dom';

export const MeetingLiveItems: FunctionComponent<IMeetingLiveItemsProps> = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const liveSessions = useSelect(meetingsSimplePageSelectors.selectLiveMeetings);

  const userId = useSelect(authSelectors.selectLoggedUser);

  const joinLiveMeeting = useCallback(
    (session) => {
      if (userId) {
        if (session.meetingMembers.includes(userId)) {
          history.push(`/live-meeting/${session.meetingId}/${session.id}`);
        } else {
          dispatch(joinMeeting(session));
        }
      }
    },
    [dispatch, userId, history],
  );

  // TODO remove added styles
  return (
    <>
      {liveSessions.length !== 0 && (
        <>
          <hr />
          <div className="menu-title">{'Live'}</div>
          <ul className="accounts-menu">
            {liveSessions.map(
              (session, index) =>
                session.meeting && (
                  <li key={index} onClick={() => joinLiveMeeting(session)} style={{ zIndex: 0, cursor: 'pointer' }}>
                    <a>
                      <CircularAvatar
                        src={session.meeting.image}
                        title={session.meeting.title}
                        color={session.meeting.color}
                        size="25"
                        classes="img-fluid mr-05"
                        textSizeRatio={3}
                      />
                      <span>{session.meeting.title}</span>
                    </a>
                  </li>
                ),
            )}
          </ul>
          <hr />
        </>
      )}
    </>
  );
};
